import { useTranslation } from 'react-i18next';
import { getTranslateName } from 'src/services/util';

export default function MySubCreatedCard({ item }: { item: CheckoutUserProduct }): JSX.Element {
  const { t } = useTranslation();

  return (
    <div className="mt-3">
      <div className="min-h-40 relative border border-ice-blue rounded bg-white p-6 flex justify-between">
        <div className="pr-7">
          <div className="N_12_M text-brown-grey">{t('product/my/sub_created_message')}</div>
          <div className="N_16_R text-black mt-5" style={{ wordBreak: 'keep-all' }}>
            {item[getTranslateName()]}
          </div>
          {/* <div className="N_12_R text-brown-grey mt-1">
            <Trans i18nKey="product/my/service_period_date" values={{ date: dayjs(item.endDate).format(calcData.format) }}></Trans>
          </div> */}
          <div className="mt-2 flex flex-wrap items-center justify-start">
            <div className="N_12_R text-brown-grey flex-shrink-0">{t('product/my/payment_no')}</div>
            <div className="division mx-1.5"></div>
            <div className="N_12_R text-black">{item.displayPaymentId}</div>
          </div>
        </div>
        <div className="flex justify-center items-center">
          <div className="w-16 h-16 rounded-full bg-light-grey-blue text-white N_12_R flex justify-center items-center">
            {t('product/my/sub_created_message_2')}
          </div>
        </div>
      </div>
    </div>
  );
}
